(()=>{
  // 视频弹窗列表
  class videoComponent extends HTMLElement{
  constructor() {
  super();
  this.playsBtns = this.querySelectorAll('[data-code]');
  this.init();
  }
  init() {
  if(this.playsBtns.length >= 1) {
  this.playsBtns.forEach((btn) => {
  btn.addEventListener('click', (e) => {
  e.target.blur();
  const videoUrl = e.target.dataset.code;
  const videoName = e.target.dataset.name;
  const videoReviwe = e.target.dataset.reviwe;
  const videoImage = e.target.dataset.image;
  const videoModel = e.target.dataset.model;
  const videoHref = e.target.dataset.href;
  const videoElement = `
  <div class="uk-container uk-section-xsmall">
      <button class="uk-modal-close-outside" type="button" uk-close></button>
      <div class="uk-margin-bottom">
          <div class="uk-grid-small uk-flex-middle" uk-grid>
              <div class="uk-width-auto">
                  <svg t="1714028096909" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="7377" width="30" height="30"><path d="M511.9488 213.97504c-83.31264 0-150.8608 67.54816-150.8608 150.86592 0 83.31264 67.54304 150.8608 150.8608 150.8608 83.31264 0 150.8608-67.54816 150.8608-150.8608S595.26144 213.97504 511.9488 213.97504zM511.85152 0.44032C229.20704 0.44032 0.07168 229.57056 0.07168 512.22016 0.07168 794.87488 229.20704 1024 511.85152 1024s511.77984-229.13024 511.77984-511.77984S794.496 0.44032 511.85152 0.44032z m264.11008 816.99328c-11.008-1.24416-22.73792-18.85696-22.73792-18.85696-20.07552-128.512-120.31488-226.29888-241.27488-226.29888-120.95488 0-221.19424 97.792-241.26976 226.29888 0 0-4.62336 17.35168-22.74304 18.85696-42.32192 3.53792-37.2224-18.85696-37.2224-18.85696 3.8912-117.96992 79.75936-218.32704 186.54208-260.9408-55.87456-37.18656-92.74368-100.66432-92.74368-172.79488 0-114.57024 92.87168-207.44704 207.44192-207.44704 114.56 0 207.4368 92.87168 207.4368 207.44704 0 72.13056-36.864 135.60832-92.73344 172.79488 106.77248 42.61376 182.64064 142.97088 186.53184 260.9408-0.01024 0.00512-2.62656 22.80448-37.22752 18.85696z" fill="#D1D1D2" p-id="7378"></path></svg>
              </div>
              <div class="uk-width-expand">
                  <p class="uk-text-meta uk-margin-remove-top">${videoName}</p>
              </div>
          </div>
      </div>
      <p class="uk-text-meta">${videoReviwe}</p>
      <iframe src="//www.youtube-nocookie.com/embed/${videoUrl}?autoplay=0&amp;showinfo=0&amp;rel=0&amp;modestbranding=1&amp;playsinline=1" width="1920" height="1080" allowfullscreen uk-responsive uk-video class="uk-responsive-width"></iframe>
      <div class="product-frame">
          <div class="uk-grid-small uk-flex-middle uk-flex-around" uk-grid>
              <div class="uk-width-1-5 uk-width-auto@s">
                  <img width="100" height="100" src="${videoImage}">
              </div>
              <div class="uk-width-2-5 uk-width-3-5@s">
                  <p class="uk-text-meta uk-margin-remove-top">${videoModel}</p>
              </div>
              <div class="uk-width-2-5 uk-width-auto@s uk-flex uk-flex-right">
                  <a href="${videoHref}" class="pr-btn">Buy Now</a>
              </div>
          </div>
      </div>
  </div>
  `
  UIkit.modal.dialog(`<div>${videoElement}<style>.uk-modal{display: flex!important;}.uk-modal-dialog {width: 1030px;margin-top: auto!important;margin-bottom: auto!important;}</style></div>`);
  });
  });
  }
  }
  }
  customElements.define('video-component-box', videoComponent);
  // 视频列表
  class e extends HTMLElement {
      constructor() {
          super()
      }
      show() {
          this.classList.remove("uk-hidden")
      }
      hide() {
          this.classList.add("uk-hidden")
      }
  }
  class i extends HTMLElement {
      constructor() {
          super(),
          this.updateSections(),
          this.querySelectorAll("[data-filter-tab]").forEach(e=>{
              e.addEventListener("click", e=>{
                  e.target.closest(".flickityt4s-slider").querySelectorAll(".t4s-collection-item-simple").forEach(e=>e.classList.remove("uk-active")),
                  e.target.closest(".t4s-collection-item-simple").classList.add("uk-active"),
                  this.updateSections(e.target.dataset.filterTab)
              }
              , !1)
          }
          )
      }
      updateSections(e) {
          e = e || "group_1";
          document.querySelectorAll("[data-filter]").forEach(e=>e.classList.add("uk-hidden")),
          document.querySelectorAll(`[data-filter="${e}"]`).forEach(e=>e.classList.remove("uk-hidden"))
      }
  }
  customElements.define("tab-video", i);
}
)();